module.exports = __webpack_public_path__ + "img/59.1.73d07b2c.jpg";